import { Check, Phone, Send, User } from "lucide-react";
import React, { useEffect, useState } from "react";
import { getAllTemplates } from "../../services/templates";
import { us_phone_code } from "../../helpers/constants";
import { notify } from "../../helpers";
import Spacing from "../Spacing";

export default function ReviewMessageModal({
  onClose = () => {},
  handleSendReview = () => {},
  patientData = {},
}) {
  const [templates, setTemplates] = useState([]);
  const [countryCode, setCountryCode] = useState("+13");
  const [reviewRequestData, setReviewRequestData] = useState({
    patient_id: 0,
    patient_name: "",
    phone_number: "",
    template_id: "",
    message: "",
  });

  const getTemplates = async () => {
    try {
      const response = await getAllTemplates();
      setTemplates(response.data);
    } catch (error) {
      // console.log("🚀 ~ getTemplates ~ error:", error);
    }
  };

  useEffect(() => {
    getTemplates();
    const patientName = `${patientData.first_name || ""} ${
      patientData.last_name || ""
    }`;
    setReviewRequestData({
      patient_id: patientData.patient_id,
      patient_name: patientName,
      phone_number: patientData.phone_number || "",
      template_id: "",
      message: "",
    });
  }, []);

  const handleChange = (e) => {
    setReviewRequestData({
      ...reviewRequestData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSendReviewRequest = () => {
    if (!reviewRequestData.patient_name || !reviewRequestData.phone_number) {
      notify(
        "error",
        "Please fill all the required fields containing steric (*).",
        3
      );
      return;
    }

    handleSendReview({
      ...reviewRequestData,
      phone_number: countryCode + reviewRequestData.phone_number,
      first_name: patientData.first_name,
      last_name: patientData.last_name,
      date_of_birth: patientData.date_of_birth,
    });
    onClose();
  };

  const handleChangeTemplate = (e) => {
    const template = templates.find(
      (template) => template.id === parseInt(e.target.value)
    );
    setReviewRequestData({
      ...reviewRequestData,
      template_id: parseInt(e.target.value),
      message: template?.message_template || "",
    });
  };

  return (
    <>
      <div className="docpro_modal_wrap">
        <div className="docpro_modal_overlay" onClick={onClose}></div>
        <div className="docpro_modal">
          <h2 className="docpro_fs_24 docpro_mb_0">Send a review request</h2>
          <Spacing lg="20" sm="20" />
          <label className="docpro_fw_500 docpro_primary_color">
            Patient’s Name *
          </label>
          <div className="docpro_form_field_with_icon">
            <input
              type="text"
              className="docpro_form_field size_lg"
              name="patient_name"
              value={reviewRequestData.patient_name}
              onChange={handleChange}
            />
            <User width={20} height={20} className="docpro_form_field_icon" />
            <Check width={20} height={20} className="docpro_form_field_icon" />
          </div>
          <Spacing lg="20" sm="20" />
          <label className="docpro_fw_500 docpro_primary_color">
            Patient’s Number *
          </label>
          <div className="docpro_form_field_with_icon_group">
            <select
              className="docpro_form_field size_lg"
              value={countryCode}
              onChange={(e) => setCountryCode(e.target.value)}
            >
              {us_phone_code.map((code, index) => (
                <option key={index} value={code}>
                  {code}
                </option>
              ))}
            </select>
            <input
              type="number"
              pattern="[2-9][0-9]{2}-[0-9]{4}"
              className="docpro_form_field size_lg"
              name="phone_number"
              onChange={handleChange}
            />
            <Phone width={20} height={20} className="docpro_form_field_icon" />
            <Check width={20} height={20} className="docpro_form_field_icon" />
          </div>
          <Spacing lg="20" sm="20" />
          <div className="docpro_label_group">
            <label className="docpro_fw_500 docpro_primary_color">
              Template
            </label>
            {/* <Link to="/" className="docpro_text_btn_2">
              <Plus width={16} height={16} />
              Create new template
            </Link> */}
          </div>
          <select
            className="docpro_form_field size_lg"
            onChange={handleChangeTemplate}
            name="template_id"
          >
            <option value="">Select Template</option>
            {templates.map((template) => (
              <option key={template.id} value={template.id}>
                {template.template_name}
              </option>
            ))}
          </select>
          <Spacing lg="20" sm="20" />
          <label className="docpro_fw_500 docpro_primary_color">Message</label>
          <textarea
            className="docpro_form_field size_lg"
            cols="30"
            rows="5"
            name="message"
            value={reviewRequestData.message}
            onChange={handleChange}
          ></textarea>
          <Spacing lg="20" sm="20" />
          <button
            onClick={handleSendReviewRequest}
            className="docpro_bordered_btn size_lg width_100 docpro_fw_600 docpro_white_color docpro_filed_btn"
          >
            <Send width={20} height={20} />
            <span>Send</span>
          </button>
        </div>
      </div>
    </>
  );
}
